import {Injectable} from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import {SsrCookieService} from "ngx-cookie-service-ssr";

@Injectable()
export class AnonymousGuard  {

  constructor(private router: Router,
              private cookieService: SsrCookieService) { }

  canActivate(state: RouterStateSnapshot) {
    if (!this.cookieService.get("role")) {
      return true;
    }
    if (this.cookieService.get("role") == 'BARMAN') {
      this.router.navigate(['/compte/informations']);
      return false;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
